import PropTypes from "prop-types";

import { eyebrowCss } from "./ContentDisplayEyebrow.style";

const propTypes = {
  eyebrow: PropTypes.string,
};
const ContentDisplayEyebrow = ({ eyebrow }) => {
  if (!eyebrow) {
    return null;
  }

  return <div css={eyebrowCss}>{eyebrow}</div>;
};

ContentDisplayEyebrow.propTypes = propTypes;

export default ContentDisplayEyebrow;
